export const getLoggedIn = (): Promise<boolean> =>
  new Promise((resolve, _reject) => {
    if (window?.ikea?.authentication) {
      window.ikea.authentication.getTokens((error, token) => {
        if (error) {
          resolve(false)
        } else {
          resolve(!!token.auth)
        }
      })
    } else {
      resolve(false)
    }
  })

export const getLoggedInUserToken = (): Promise<string> =>
  new Promise((resolve, _reject) => {
    if (window?.ikea?.authentication) {
      window.ikea.authentication.getTokens((error, token) => {
        resolve(error ? '' : token?.auth?.value || '')
      })
      return
    }
    resolve('')
  })
